<template>
  <div 
    class="card flex-col-nowrap rounded-card shadow-2x8 max-w-2xl"
    :class="margin"
  >
    <header 
      v-if="$slots.header" 
      class="header bg-header-bgcolor rounded-t-card text-base text-white text-center"
      :class="mode"
    >
      <slot name="header"></slot>
    </header>
    <div 
      class="body flex-col-nowrap justify-center items-center"
      :class="mode"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
        padding: {
          type: String,
          requiered: false,
          default: 'padNormal'
        },
        margin: {
          type: String,
          requiered: false,
          default: 'marNormal'
        },
        mode: {
          type: String,
          requiered: false,
          default: ''
        }
 }
}
</script>
<style scoped>

  .pad0 {
    padding: 0px;
  }

  .padNormal {
    padding: 1rem;
  }

  .marNormal {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: auto;
    margin-right: auto;
  }

  .mar0 {
    margin: 0px !important;
  }

</style>
